export default "__VITE_ASSET__8fb7ca66__"